const primaryMain = '#081994';
const primaryMainOpacity = 'rgba(8, 25, 148, 0.9)';
const secondaryMain = '#7D2421';
const secondaryMainOpacity = 'rgba(125, 36, 33, 0.5)';
const secondaryLight = '#febe57';
const tertiaryMain = '#1D3E93';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
